import React, {PureComponent, ReactNode} from "react"
import styled from "styled-components"

import {H2} from "@irati/ui/src/Typography"
import Count from "@irati/ui/src/Count"
import Flex from "@irati/ui/src/Flex"

const StyledFlex = styled(Flex)`
  min-width: 200px;
`

const StyledH2 = styled(H2)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  word-break: break-all;
  max-width: 250px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    max-width: 400px;
  `}
`
interface Props {
  title?: string | ReactNode,
  count?: number | string | ReactNode,
  marginBottom?: number
}

class HeaderTitle extends PureComponent<Props> {
  render() {
    const {title, count, marginBottom} = this.props

    return (
      <StyledFlex alignItems="baseline">
        <StyledH2 marginBottom={marginBottom || 4}>{title}</StyledH2>
        {count && <Count>{count}</Count>}
      </StyledFlex>
    )
  }
}

export default HeaderTitle
